import { render, staticRenderFns } from "./babyloan-ko-form-ok.pug?vue&type=template&id=23706ede&scoped=true&lang=pug&external"
import script from "./babyloan-ko-form-ok.js?vue&type=script&lang=js&external"
export * from "./babyloan-ko-form-ok.js?vue&type=script&lang=js&external"
import style0 from "./babyloan-ko-form-ok.vue?vue&type=style&index=0&id=23706ede&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "23706ede",
  null
  
)

export default component.exports